var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',{attrs:{"title":"Editar plantilla"}},[_c('formulario',{attrs:{"plantilla-contenido":_vm.plantillaContenido,"paises-id":_vm.paisesId},on:{"submit":_vm.insertar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }